import { BaivietService } from 'src/services/baiviet.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const BAIVIET_NEW_CARE_SUCCESS = 'BAIVIET:NEW_CARE_SUCCESS'
export const BAIVIET_LIST_SUCCESS = 'BAIVIET:FIND_ALL_SUCCESS'
export const BAIVIET_LIST_FAILD = 'BAIVIET:FIND_ALL_FAILD'
export const BAIVIET_COUNT_ASSIGN_SUCCESS = 'BAIVIET:COUNT_ASSIGN_SUCCESS'
export const BAIVIET_COUNT_ASSIGN_FAILD = 'BAIVIET:COUNT_ASSIGN_FAILD'

export const BAIVIET_CREATE_SUCCESS = 'BAIVIET:CREATE_SUCCESS'
export const BAIVIET_CREATE_FAILD = 'BAIVIET:CREATE_FAILD'

export const BAIVIET_IMPORT_SUCCESS = 'BAIVIET:IMPORT_SUCCESS'
export const BAIVIET_SAVE_SUCCESS = 'BAIVIET:SAVE_SUCCESS'
export const BAIVIET_SAVE_FAILD = 'BAIVIET:SAVE_SUCCESS'

export const BAIVIET_DEL_SUCCESS = 'BAIVIET:DEL_SUCCESS'
export const BAIVIET_DEL_FAILD = 'BAIVIET:DEL_FAILD'

export const BAIVIET_ONE_SUCCESS = 'BAIVIET:FIND_ONE_SUCCESS'
export const BAIVIET_ONE_FAILD = 'BAIVIET:FIND_ONE_FAILD'

export const BAIVIET_HISTORY_LIST_SUCCESS = 'BAIVIET:HISTORY_FIND_ALL_SUCCESS'
export const BAIVIET_HISTORY_LIST_FAILD = 'BAIVIET:HISTORY_FIND_ALL_FAILD'

export const BAIVIET_UPDATE_FILTER = 'BAIVIET:UPDATE_FILTER'

export const BAIVIET_UPDATE_HOMEPAGE_FILTER = 'BAIVIET:BAIVIET_UPDATE_HOMEPAGE_FILTER'

export const BAIVIET_HOMEPAGE_LIST_SUCCESS = 'BAIVIET:FIND_HOMEPAGE_LIST_SUCCESS'
export const BAIVIET_HOMEPAGE_LIST_FAILD = 'BAIVIET:FIND_HOMEPAGE_LIST_FAILD'

export const BAIVIET_HOMEPAGE_ONE_SUCCESS = 'BAIVIET:FIND_HOMEPAGE_ONE_SUCCESS'
export const BAIVIET_HOMEPAGE_ONE_FAILD = 'BAIVIET:FIND_HOMEPAGE_ONE_FAILD'

export const BAIVIET_LIMIT_UPDATE_HOMEPAGE_FILTER = 'BAIVIET:BAIVIET_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const BAIVIET_LIMIT_HOMEPAGE_LIST_SUCCESS = 'BAIVIET:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const BAIVIET_LIMIT_HOMEPAGE_LIST_FAILD = 'BAIVIET:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const BAIVIET_LIMIT_HOMEPAGE_ONE_SUCCESS = 'BAIVIET:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const BAIVIET_LIMIT_HOMEPAGE_ONE_FAILD = 'BAIVIET:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const BAIVIET_KHONG_NOI_BAT_LIMIT_UPDATE_HOMEPAGE_FILTER = 'BAIVIET:BAIVIET_KHONG_NOI_BAT_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_LIST_SUCCESS = 'BAIVIET:KHONG_NOI_BAT_LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_LIST_FAILD = 'BAIVIET:KHONG_NOI_BAT_LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_ONE_SUCCESS = 'BAIVIET:KHONG_NOI_BAT_LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_ONE_FAILD = 'BAIVIET:KHONG_NOI_BAT_LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const TINTUC_UPDATE_HOMEPAGE_FILTER = 'TINTUC:TINTUC_UPDATE_HOMEPAGE_FILTER'

export const TINTUC_HOMEPAGE_LIST_SUCCESS = 'TINTUC:FIND_HOMEPAGE_LIST_SUCCESS'
export const TINTUC_HOMEPAGE_LIST_FAILD = 'TINTUCFIND_HOMEPAGE_LIST_FAILD'

export const TINTUC_HOMEPAGE_ONE_SUCCESS = 'TINTUCFIND_HOMEPAGE_ONE_SUCCESS'
export const TINTUC_HOMEPAGE_ONE_FAILD = 'TINTUC:FIND_HOMEPAGE_ONE_FAILD'

export const BaivietAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,

    homepageList,
    updateHomepageFilter,
    homepageFindOne,

    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,

    homepageKhongNoiBatLimitList,
    updateHomepageKhongNoiBatLimitFilter,
    homepageKhongNoiBatLimitFindOne,

    homepageTintucList,
    updateHomepageTintucFilter,
    homepageTintucFindOne,
}

function updateHomepageTintucFilter(payload) {
    return { type: TINTUC_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageTintucList() {
    return (dispatch, getState) => {
        const { baiviet } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageTintucFilter } = baiviet;
        const homepageTintucPage = homepageTintucFilter.homepageTintucPage;
        const homepageTintucLimit = homepageTintucFilter.homepageTintucLimit;

        return new Promise((resolve, reject) => {
            BaivietService.homepageTintucList(homepageTintucFilter).then((rs) => {
                if (!!homepageTintucFilter && homepageTintucFilter.homepageTintucPage === 0) {
                    dispatch(success({
                        homepageTintucItems: rs.data.values,
                        homepageTintucTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = baiviet.homepageTintucItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageTintucLimit * homepageTintucPage; i < homepageTintucLimit * homepageTintucPage + homepageTintucLimit; i++) {
                        if (typeof rsDataValues[i - homepageTintucLimit * homepageTintucPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageTintucLimit * homepageTintucPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageTintucItems: uniqueItems,
                        homepageTintucTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: TINTUC_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: TINTUC_HOMEPAGE_LIST_FAILD, error } }
}

function homepageTintucFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.homepageTintucFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TINTUC_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: TINTUC_HOMEPAGE_ONE_FAILD, error } }
}

//==========

function updateHomepageFilter(payload) {
    return { type: BAIVIET_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { baiviet } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageBaivietFilter } = baiviet;
        const homepageBaivietPage = homepageBaivietFilter.homepageBaivietPage;
        const homepageBaivietLimit = homepageBaivietFilter.homepageBaivietLimit;

        return new Promise((resolve, reject) => {
            BaivietService.homepageList(homepageBaivietFilter).then((rs) => {
                if (!!homepageBaivietFilter && homepageBaivietFilter.homepageBaivietPage === 0) {
                    dispatch(success({
                        homepageBaivietItems: rs.data.values,
                        homepageBaivietTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = baiviet.homepageBaivietItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageBaivietLimit * homepageBaivietPage; i < homepageBaivietLimit * homepageBaivietPage + homepageBaivietLimit; i++) {
                        if (typeof rsDataValues[i - homepageBaivietLimit * homepageBaivietPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageBaivietLimit * homepageBaivietPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageBaivietItems: uniqueItems,
                        homepageBaivietTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: BAIVIET_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_HOMEPAGE_ONE_FAILD, error } }
}

//==========

function updateHomepageLimitFilter(payload) {
    return { type: BAIVIET_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { baiviet } = getState();
        // dispatch(AppAction.appLoading(true));

        const { homepageBaivietLimitFilter } = baiviet;
        const homepageBaivietLimitPage = homepageBaivietLimitFilter.homepageBaivietLimitPage;
        const homepageBaivietLimitLimit = homepageBaivietLimitFilter.homepageBaivietLimitLimit;

        return new Promise((resolve, reject) => {
            BaivietService.homepageLimitList(homepageBaivietLimitFilter).then((rs) => {
                if (!!homepageBaivietLimitFilter && homepageBaivietLimitFilter.homepageBaivietLimitPage === 0) {
                    dispatch(success({
                        homepageBaivietLimitItems: rs.data.values,
                        homepageBaivietLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = baiviet.homepageBaivietLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageBaivietLimitLimit * homepageBaivietLimitPage; i < homepageBaivietLimitLimit * homepageBaivietLimitPage + homepageBaivietLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageBaivietLimitLimit * homepageBaivietLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageBaivietLimitLimit * homepageBaivietLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageBaivietLimitItems: uniqueItems,
                        homepageBaivietLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: BAIVIET_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

//==========

function updateHomepageKhongNoiBatLimitFilter(payload) {
    return { type: BAIVIET_KHONG_NOI_BAT_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageKhongNoiBatLimitList() {
    return (dispatch, getState) => {
        const { baiviet } = getState();
        // dispatch(AppAction.appLoading(true));

        const { homepageBaivietKhongNoiBatLimitFilter } = baiviet;
        const homepageBaivietKhongNoiBatLimitPage = homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitPage;
        const homepageBaivietKhongNoiBatLimitLimit = homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitLimit;

        return new Promise((resolve, reject) => {
            BaivietService.homepageKhongNoiBatLimitList(homepageBaivietKhongNoiBatLimitFilter).then((rs) => {
                if (!!homepageBaivietKhongNoiBatLimitFilter && homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitPage === 0) {
                    dispatch(success({
                        homepageBaivietKhongNoiBatLimitItems: rs.data.values,
                        homepageBaivietKhongNoiBatLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = baiviet.homepageBaivietKhongNoiBatLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageBaivietKhongNoiBatLimitLimit * homepageBaivietKhongNoiBatLimitPage; i < homepageBaivietKhongNoiBatLimitLimit * homepageBaivietKhongNoiBatLimitPage + homepageBaivietKhongNoiBatLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageBaivietKhongNoiBatLimitLimit * homepageBaivietKhongNoiBatLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageBaivietKhongNoiBatLimitLimit * homepageBaivietKhongNoiBatLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageBaivietKhongNoiBatLimitItems: uniqueItems,
                        homepageBaivietKhongNoiBatLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageKhongNoiBatLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.homepageKhongNoiBatLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

//==========

function updateFilter(payload) {
    return { type: BAIVIET_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            BaivietService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(BaivietAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: BAIVIET_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            BaivietService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(BaivietAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: BAIVIET_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { baiviet } = getState()
        dispatch(AppAction.appLoading(true));
        BaivietService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...baiviet.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { baiviet } = getState();
        const page = baiviet && typeof baiviet.filter !== 'undefined' && baiviet.filter && typeof baiviet.filter.page !== 'undefined' ? baiviet.filter.page : 0;
        const limit = baiviet && typeof baiviet.filter !== 'undefined' && baiviet.filter && typeof baiviet.filter.limit !== 'undefined' ? baiviet.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            BaivietService.findAll(page, limit, baiviet.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = baiviet.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: BAIVIET_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: BAIVIET_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            BaivietService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(BaivietAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: BAIVIET_SAVE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            BaivietService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(BaivietAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
                alert("Không thể tạo, có thể do trùng tên bài viết trước đó!");
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: BAIVIET_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(BaivietAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_CREATE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(BaivietAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_DEL_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_ONE_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        BaivietService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(BaivietAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { baiviet } = getState()
        dispatch(AppAction.appLoading(true));
        BaivietService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...baiviet.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: BAIVIET_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: BAIVIET_HISTORY_LIST_FAILD, error } }
}